export const previewProps = (photo) => {
  const {
    size: { title: size, area },
  } = photo;

  return {
    isWallet: size === 'Wallet',
    size_area: area,
    recommendedPrintSize: null,
    showSize: false,
    showQuantity: false,
    showLowQualityWarning: true,
  };
};
